<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import cookies from 'js-cookie'

export default {
  name: 'App',
  created () {
    if (process.env.NODE_ENV === 'development') {
      setTimeout(() => {
        let auth = ['auth-all', 'readOnly', 'edit', 'add', 'delete']
        // let auth = ['auth-all']
        // sessionStorage.setItem('auth', JSON.stringify(auth))
      }, 100)
      // cookies.set('satoken', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjEsInJuU3RyIjoiSVhsSGt6a2loZEFxZGEwb1VjYzBiNmdaZGxSZVcxVHcifQ.cLb9cK3XmuqZK3R-kVFdd6dt1xBcT0KwvyW4MZomF4k') // 多企业
      // cookies.set('satoken', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjcxNzcwMTQ2MzU5ODg2MzAsInJuU3RyIjoiM1cyaG1zaDVpcWRmUTNpNzdVQ1JBWEdIUmRyQVgwQUkifQ.wrMzi2GN6-9lIUCYidjDRQ75zOmzuPWnuoPaD68BcMs')
      // cookies.set('satoken', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjcxNzcwMDgzNjU0MjE4NzYsInJuU3RyIjoiYVVvdXVnOTNVOTRQVnIwRnoxSHR6ZTVjNno0bjJqWEIifQ.7DNOGQIo4LsUNteQsjmI0-4k5Owwo1AOMWtlM21SWnA') // 员工
    }
  },
  methods: {

  }
}
</script>
